// All steps which are visible in the dialog, the enum here defines the order!
export enum INVOICE_CREATION_PROCESS_STEP {
    SETTINGS,
    RESULT
}
export const InvoiceCreationProcessStepLabels: { [K in INVOICE_CREATION_PROCESS_STEP]: string } = {
    [INVOICE_CREATION_PROCESS_STEP.SETTINGS]: $localize`Settings`,
    [INVOICE_CREATION_PROCESS_STEP.RESULT]: $localize`Completion`
};

export enum BusinessPartnerType {
    CUSTOMERS = 'CUSTOMERS',
    CENTRAL_REGULATORS = 'CENTRAL_REGULATORS'
}
export const BusinessPartnerTypeLabels: { [K in BusinessPartnerType]: string } = {
    [BusinessPartnerType.CUSTOMERS]: $localize`Customers`,
    [BusinessPartnerType.CENTRAL_REGULATORS]: $localize`Central Regulators`
};

export enum InvoicingType {
    PRODUCT_INVOICE = 'PRODUCT_INVOICE',
    PLATFORM_LICENSE_INVOICE = 'PLATFORM_LICENSE_INVOICE'
}
export const InvoicingTypeLabels: { [K in InvoicingType]: string } = {
    [InvoicingType.PRODUCT_INVOICE]: $localize`Products`,
    [InvoicingType.PLATFORM_LICENSE_INVOICE]: $localize`Licenses`
};

export interface InvoiceCreationProcessData {
    businessPartnerType?: BusinessPartnerType;
    businessPartnerIds?: string[];
    invoicingType?: InvoicingType;
    locale?: InvoiceCreationLocale;
}

export enum InvoiceCreationLocale {
    de = 'de',
    en = 'en'
}
export const InvoiceCreationLocaleLabels: { [K in InvoiceCreationLocale]: string } = {
    [InvoiceCreationLocale.de]: 'DE - ' + $localize`German`,
    [InvoiceCreationLocale.en]: 'EN - ' + $localize`English`
};
